import { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';

const FlameIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
  </svg>
);

const MARCOS = [
  { dias: 7,  nome: 'Semana Inteira' },
  { dias: 21, nome: 'Hábito Formado' },
  { dias: 30, nome: 'Mês Completo' },
];

function getProximoMarco(streak) {
  return MARCOS.find(m => streak < m.dias) || null;
}

function toISO(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export default function StreakCounter({ streak, hero = false }) {
  const [percentile, setPercentile] = useState(null);

  const proximoMarco = getProximoMarco(streak || 0);

  useEffect(() => {
    if (!hero || !streak || proximoMarco) return;

    async function fetchPercentile() {
      const today = new Date();
      const since = new Date(today);
      since.setDate(today.getDate() - streak + 1);
      const sinceStr = toISO(since);

      const { count: total } = await supabase
        .from('daily_logs')
        .select('user_id', { count: 'estimated', head: true })
        .eq('completed', true);

      const { count: ativosNoPeriodo } = await supabase
        .from('daily_logs')
        .select('user_id', { count: 'estimated', head: true })
        .eq('completed', true)
        .gte('date', sinceStr);

      if (!total || total === 0) return;
      const pct = Math.round(((total - ativosNoPeriodo) / total) * 100);
      if (pct > 0) setPercentile(pct);
    }

    fetchPercentile();
  }, [hero, streak, proximoMarco]);

  if (!streak || streak === 0) return null;

  if (hero) {
    const diasTexto = streak === 1 ? '1 dia' : `${streak} dias`;
    const faltam = proximoMarco ? proximoMarco.dias - streak : 0;

    return (
      <div className="streak-hero">
        <div className="streak-hero-left">
          <span className="streak-hero-icon"><FlameIcon size={20} /></span>
          <span className="streak-hero-count">{diasTexto} em sequência</span>
        </div>

        {proximoMarco && (
          <div style={{
            marginTop: 10,
            display: 'flex', alignItems: 'center', gap: 8,
            background: 'rgba(196, 135, 61, 0.12)',
            border: '1px solid rgba(196, 135, 61, 0.3)',
            borderRadius: 10, padding: '8px 12px',
          }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c4873d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
            </svg>
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 500, color: '#c4873d' }}>
              Faltam <strong>{faltam} {faltam === 1 ? 'dia' : 'dias'}</strong> para "{proximoMarco.nome}"
            </span>
          </div>
        )}

        {!proximoMarco && percentile !== null && (
          <div style={{
            marginTop: 10,
            display: 'flex', alignItems: 'center', gap: 8,
            background: 'rgba(123,94,167,0.1)',
            border: '1px solid rgba(123,94,167,0.25)',
            borderRadius: 10, padding: '8px 12px',
          }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--lavender)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
            </svg>
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 500, color: 'var(--lavender)' }}>
              Você já construiu mais consistência do que <strong>{percentile}%</strong> das pessoas conseguem manter
            </span>
          </div>
        )}
      </div>
    );
  }

  const texto = streak === 1 ? '1 dia em sequência' : `${streak} dias em sequência`;
  return (
    <div className="streak-line">
      <FlameIcon />
      <span>{texto}</span>
    </div>
  );
}
